module.exports = __webpack_public_path__ + "images/emoji/persevere.cf29109d2d15df1fa70a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/persevere.png
// module id = 8f3B
// module chunks = 13